import { Components, Theme } from '@mui/material';

export const MuiStack = {
  defaultProps: {
    useFlexGap: true
  }
} as Components<Theme>['MuiStack'];